import { useMemo } from "react";

export const usePinIcon = (siteVariant: string) => {
    const mapPinSrc = useMemo(() => {
        switch (siteVariant) {
            case "danish-agro":
                return "/pin_green.png"; // Provide the actual path to your first PNG image
            case "vilofarm":
                return "/pin_blue.png";
            case "agro-business":
                return "/pin_green.png";
            case "vilomix":
                return "/pin_blue.png";
            case "wildbird":
                return "/pin_wildbird.png";
            case "Trinol":
                return "/pin_trinol.png";
            case "agrosan":
                return "/pin_agrosan.png";
            case "red":
                return "/pin_red.png";
            case "orange":
                return "/pin_orange.png";
            case "blue":
                return "/pin_blue.png";
            case "energipark-valloe":
                return "/pin_energipark_valloe.png";
            default:
                return "/pin_green.png"; // Default case
        }
    }, [siteVariant]);

    return {
        mapPinSrc,
    };
};
